import React from "react";
import { couple, navLinks } from "../mock";

export default function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="border-t border-[#211E1A]/12 py-10 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-6">
          <a href="#top" onClick={(e) => scrollTo(e, "#top")} className="font-serif-display text-2xl text-[#211E1A]">
            {couple.initials}
          </a>
          <span className="w-1 h-1 rounded-full bg-[#9E2B25] hidden sm:block" />
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => scrollTo(e, l.href)}
                className="link-underline text-[11px] uppercase tracking-widest-2 text-[#211E1A] hover:text-[#9E2B25] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <a
          href="https://mozeid.com/"
          target="_blank"
          rel="noreferrer"
          className="link-underline text-[11px] uppercase tracking-widest-2 text-[#6b6157] hover:text-[#9E2B25] transition-colors"
        >
          Designed by Mo Studio
        </a>
      </div>
    </footer>
  );
}
